<template>
    <div style="width: 100%; height: 100%">

      <div v-for="(item,index) in fileList" :key="index">
        <template >
          <img
            class="el-upload-list__item-thumbnail"
            :src="require('@/assets/images/video_default.jpg')"
            alt=""
            v-if="!item.uploading"
          >
          <el-progress v-else type="circle" :percentage="item.percentage" ></el-progress>
          <span class="el-upload-list__item-actions flex_middle" >
            <span class="el-upload-list__item-preview">
              <img src="@/assets/images/play.png" alt="" @click="onPlayVideo(file)">
            </span>
            <span class="el-upload-list__item-delete" @click="onRemove(file)">
              <i class="el-icon-delete" />
            </span>
          </span>
        </template>
      </div>

      <!-- 视频预览 -->
      <el-dialog
        v-if="showVideoPlay"
        title="视频预览"
        :visible.sync="showVideoPlay"
        append-to-body
        :close-on-click-modal="false"
      >
        <!-- 每次打开重新加载播放器 -->
        <div id="J_prismPlayer" ></div>
      </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import {
  video_upload,
  video_refresh,
  video_playAuth,
  video_cover
} from '@/api/video'
import Player from 'xgplayer';
import bus from '@/utils/bus'

export default {
  props: {
    file: {
      type: Object,
      default: () => null
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showVideoPlay: false,
      player: null, // 播放器实例
    }
  },
  watch:{

  },
  mounted(){

  },
  methods: {
    ...mapMutations({
      onRemoveFile: 'upload/onRemoveFile'
    }),

    // 播放视频 click
    async onPlayVideo(file) {
      this.showVideoPlay = true
      this.$nextTick(()=>{
        this.player = new Player({
          id: 'J_prismPlayer',
          url: file.url,
          height: '500px',
          width: '100%',
        });
      })
    },
    // 删除视频文件（包括正在上传）
    onRemove(file) {
      this.$emit('onRemove', file)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: transparent;
}
</style>
